import { render, staticRenderFns } from "./NrcCompetitorProductAutocomplete.vue?vue&type=template&id=264b0032&"
import script from "./NrcCompetitorProductAutocomplete.vue?vue&type=script&setup=true&lang=js&"
export * from "./NrcCompetitorProductAutocomplete.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports